import React, { useState, useEffect } from 'react';
import { setSelectedShippingData } from '../../../../../redux/checkoutredux/actions/checkoutactions/checkoutActions'; // Import der Versand-Aktion
import CO_ManageData from '../../../CO_ManageData'; 

const BlockDeliveryMethod = ({store}) => {
  const [selectedShipping, setSelectedShipping] = useState(null);
  const currency = store.getState().generalsettings.generalSettings.currency;
  //const shippingmethods = store.getState().deliverymethods;
  const shippingmethods = store.getState().shoppingcart.metacartdata[0].shippingmethods;
     /************ SELECTED ************** */
  const [nowShippingmethodsData, setShippingMethodsData] = useState(store.getState().shoppingcart.metacartdata[0].shippingmethods || null);
  console.log("The new shippingmethods: ",shippingmethods);
  
  

  console.log("Currency: ",currency);


  useEffect(() => {
    const unsubscribe = store.subscribe(() => {
      setShippingMethodsData(store.getState().shoppingcart.metacartdata[0].shippingmethods || null);
   
    });
  
    return () => {
      unsubscribe();
    };
  }, []);




  const handleLocationChange = (index, methodid, id, title, price) => {
    const deliveryMethod = { index: index, methodid: methodid, id: id, title: title, pricewithtax: price };
   // store.dispatch(setDeliveryMethodCurrent(deliveryMethod));
    store.dispatch(setSelectedShippingData(deliveryMethod));
    
  
    setSelectedShipping(index);
    console.log("Selected: ", deliveryMethod);
  };



  useEffect(() => {
   // let shippingcurrent = store.getState().deliverymethodcurrent.deliverymethodcurrent;
    let shippingcurrent = store.getState().selectedorderdata.shippingdata;
    console.log("Shippingmethods 0000: ",shippingmethods);
    console.log("Shippingmethods 0000 NEW: ",nowShippingmethodsData);
    
    console.log("Shippingcurrent: ",shippingcurrent);
   // setSelectedShipping(shippingcurrent.deliverymethod[0]);
   if (shippingcurrent != null && ((shippingcurrent.length > 0) ||  Object.keys(shippingcurrent).length > 0)) {
    console.log("First");
    let shppingblock = CO_ManageData.checkSelectedShipping(shippingcurrent, nowShippingmethodsData);
    handleLocationChange(shppingblock.index, shppingblock.methodid, shppingblock.id, shppingblock.title, shppingblock.price);
    //setSelectedShipping(shppingindex);

    console.log("Selected start00: ", shippingcurrent);

   }else if ((shippingcurrent === null || ( Object.keys(shippingcurrent).length === 0)) && nowShippingmethodsData.length > 0) {
      // Wenn kein Versand ausgewählt ist, wähle automatisch die erste Versandmethode aus
      console.log("NULL Shippingmethods 1111: ",nowShippingmethodsData);
      let shppingblock = CO_ManageData.checkSelectedShipping(shippingcurrent, nowShippingmethodsData);
      handleLocationChange(shppingblock.index, shppingblock.methodid, shppingblock.id, shppingblock.title, shppingblock.price);
      //store.dispatch(setDeliveryMethodCurrent(0));
    
    /*  if(shippingmethods.deliverymethod[0].method_id !== "local_pickup"){
        setSelectedShipping(0);
      }else{
      setSelectedShipping(1); // Wähle den Index der ersten Versandmethode aus
      }*/
    }
  }, [nowShippingmethodsData]);
  

  // Effekt zum Wiederherstellen des ausgewählten Standorts beim Rendern
  useEffect(() => {
   // let shippingcurrent = store.getState().deliverymethodcurrent.deliverymethodcurrent;

   /*
    let shippingcurrent = store.getState().selectedorderdata.shippingdata;
    if (shippingcurrent != null){ 
    setSelectedShipping(shippingcurrent.index);
    console.log("Selected start01: ",shippingcurrent);
    }

    console.log("All Shipping Methods: ",shippingmethods);
    console.log("Selected Shipping: ",selectedShipping);
    */
    // Prüfe, ob ein ausgewählter Standort gespeichert ist
    
    if (selectedShipping !== null) {
      // Selektiere den entsprechenden Radio-Button
      const radioElement = document.getElementById(`shippingMethod${selectedShipping}`);
      if (radioElement !== null) {
        // Wenn das Element gefunden wurde, setze seine Eigenschaften
        radioElement.checked = true;
      } else {
        // Wenn das Element nicht gefunden wurde, gib eine Warnung aus
        console.warn(`Radio button with ID shippingMethod${selectedShipping} not found.`);
      }
    }
    
  }, [selectedShipping]); // Führe den Effekt bei Änderungen von selectedShipping aus

  return (
    <div id="ips-pickup-details" className="ips-module">
      <div className="row g-3">
        <h4 className="mb-3">Versandart</h4>
        <div className="list-group">
          {nowShippingmethodsData.map((shipping, index) => (
            shipping.method_id !== "local_pickup" && (
              <label className="list-group-item ips-checkout-deliverymethod-select" key={index}>
                <div className="row">
                  <div className="col-10 p-0">
                    <div className="row g-3">
                      <div className="col-1 d-flex align-items-center justify-content-center">
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="shippingMethod"
                            id={`shippingMethod${index}`}
                            value={shipping.title}
                            checked={selectedShipping === index}
                            /* onChange={() => handleLocationChange(index)} */
                           
                            onChange={() => handleLocationChange(index, shipping.method_id, shipping.id, shipping.title, shipping.pricewithtax)}
                          />
                        </div>
                      </div>
                      <div className="col-11">
                        <div className="row flex pb-2 ips-checkout-bold-title" htmlFor={`shippingMethod${index}`} dangerouslySetInnerHTML={{ __html: shipping.title }} />
                        <div className="row flex" dangerouslySetInnerHTML={{ __html: shipping.description }} />
                      </div>
                    </div>
                  </div>
                  <div className="col-2 p-2 d-flex justify-content-center">
                  <div
                      className="row flex pb-2"
                      htmlFor={`shippingMethod${index}`}
                      style={{ whiteSpace: 'nowrap' }}
                      dangerouslySetInnerHTML={{
                        __html: `${(parseFloat(shipping.pricewithtax)).toFixed(2)} ${currency}`
                      }}
                    ></div>
                    <div className="row flex">
                    </div>
                  </div>
                </div>
              </label>
            )
          ))}
        </div>
      </div>
    </div>
  );
};

export default BlockDeliveryMethod;